import { render, staticRenderFns } from "./TicketLoading.vue?vue&type=template&id=85686cd2&"
import script from "./TicketLoading.vue?vue&type=script&lang=js&"
export * from "./TicketLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports